import { jsx } from "react/jsx-runtime";
import "react";
import { LoadingStateContext } from "./LoadingStateContext.js";
const LoadingStateProvider = ({ children, value })=>/*#__PURE__*/ jsx(LoadingStateContext.Provider, {
        value: value,
        children: children
    });
export { LoadingStateProvider };
